export const isPackOpen = ({ packNFT }) =>
  packNFT?.status === 'Opened' ||
  // @TODO: remove the "Revealed" check. it seems there was a regression and
  // probably misunderstanding on how the API should behave around pack opening.
  packNFT?.status === 'Revealed';
